module.exports = __webpack_public_path__ + "static/media/solar_water_heater.99064f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/solar_water_heater.png
// module id = 451
// module chunks = 0